/** 私有投放素材真实预览；缩略图可按统一比例裁边留白，点击放大查看原比例，对象 URL 随生命周期释放。 */
import { useEffect, useState } from 'react';
import { landingAssetsApi } from '~/hooks/use-landing-assets';
import { Dialog } from '~/ui/Dialog';
export function LandingAssetImage({
  r2Key,
  name,
  compact = false,
  aspectRatio,
  zoomable = false,
}: {
  r2Key: string;
  name: string;
  compact?: boolean;
  /** 统一缩略图比例（如 '4 / 3'），图片以 contain 居中，不裁切原图。 */
  aspectRatio?: string;
  /** 点击缩略图弹窗查看原比例大图。 */
  zoomable?: boolean;
}) {
  const [url, setUrl] = useState<string | null>(null);
  const [failed, setFailed] = useState(false);
  const [zoomed, setZoomed] = useState(false);
  useEffect(() => {
    let mounted = true;
    let objectUrl: string | null = null;
    setFailed(false);
    setUrl(null);
    void landingAssetsApi
      .previewUrl(r2Key)
      .then((value) => {
        objectUrl = value;
        if (mounted) setUrl(value);
        else URL.revokeObjectURL(value);
      })
      .catch(() => {
        if (mounted) setFailed(true);
      });
    return () => {
      mounted = false;
      if (objectUrl) URL.revokeObjectURL(objectUrl);
    };
  }, [r2Key]);
  const fixedFrame = aspectRatio !== undefined;
  const image = url && !failed && (
    <img
      src={url}
      alt={name}
      onError={() => setFailed(true)}
      style={{
        display: 'block',
        width: '100%',
        height: fixedFrame ? '100%' : undefined,
        maxHeight: fixedFrame ? undefined : compact ? 48 : 220,
        objectFit: 'contain',
      }}
    />
  );
  return (
    <>
      <div
        style={{
          minHeight: fixedFrame ? undefined : compact ? 48 : 160,
          width: compact ? 48 : '100%',
          height: compact ? 48 : undefined,
          aspectRatio,
          flexShrink: 0,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          overflow: 'hidden',
          background: 'var(--bg-subtle)',
          borderRadius: 'var(--radius)',
        }}
      >
        {image ? (
          zoomable ? (
            <button
              type="button"
              className="focusable"
              aria-label={`放大查看 ${name}`}
              title="点击放大"
              onClick={() => setZoomed(true)}
              style={{
                width: '100%',
                height: '100%',
                padding: 0,
                border: 0,
                background: 'transparent',
                cursor: 'zoom-in',
              }}
            >
              {image}
            </button>
          ) : (
            image
          )
        ) : (
          <span className="muted" style={{ fontSize: compact ? 'var(--text-2xs)' : undefined }}>
            {compact ? (failed ? '无预览' : '加载…') : failed ? '素材预览不可用' : '加载素材…'}
          </span>
        )}
      </div>
      {zoomed && url && (
        <Dialog title={name} width={960} onClose={() => setZoomed(false)}>
          <img
            src={url}
            alt={name}
            style={{
              display: 'block',
              maxWidth: '100%',
              maxHeight: '75vh',
              margin: '0 auto',
              objectFit: 'contain',
            }}
          />
        </Dialog>
      )}
    </>
  );
}
